<template>
  <div>
    <TableList
      ref="table"
      :cols="cols"
      :list="list"
      :height="tableHeight"
      :rowHeight="100"
    >
      <template slot="operateSubTypeSlot" slot-scope="{ row }">
        {{operateSubTypeMap[row.operateSubType] || ''}}
      </template>
      <template slot="operateStatusSlot" slot-scope="{ row }">
        {{operateStatusMap[row.operateStatus] || ''}}
      </template>
      <template slot="staffIdSlot" slot-scope="{ row }">
        <span>{{staffMap[row.staffId]}}</span>
      </template>
      <template slot="opcolsSlot" slot-scope="{ row }">
        <el-button
          type="link"
          @click="jumpDetail(row)"
          >查看明细</el-button
        >
      </template>
    </TableList>
  </div>
</template>

<script>
import TableList from "@/components/TableList.vue";
import tableMixins from '@mixins/table-mixins';
import { mapActions, mapMutations, mapGetters} from "vuex";
import {getStaffList} from '@servers/base/user/index.js';
import { PROD_MODIFY_STATUS,PROD_MODIFY_OPERATE_SUB_TYPE } from '../../dictionary'

export default {
  props: {
    list: {
      type: Array,
      default() {
        return [];
      },
    },
    mode: {
      type: String,
      default: "supplier",
    },
  },
  mixins: [new tableMixins(176,{ refName:'search' })],
  components: {
    TableList,
  },
  data() {
    return {
      cols: [
        { prop: "startTime", attrs: { label: "修改时间" } },
        { prop: "operateSubType", attrs: { label: "途径",width:'120px' },slot: true },
        { prop: "operateContent", attrs: { label: "操作内容" } },
        { prop: "operateStatus", attrs: { label: "状态" },slot: true },
        { prop: "staffId", attrs: { label: "操作人" } },
        { prop: "totalNum", attrs: { label: "修改商品总数" } },
        { prop: "successNum", attrs: { label: "修改成功数" } },
        { prop: "failedNum", attrs: { label: "修改失败数" } },
        { prop: "opcols", attrs: { label: "操作" }, slot: true }
      ],
      staffMap:{}
    };
  },
  computed: {
    ...mapGetters(['routerPrefix']),
    operateSubTypeMap(){
      let map = {}
      PROD_MODIFY_OPERATE_SUB_TYPE.forEach(item => {
        map[item.value] = item.label
      });
      return map
    },
    operateStatusMap(){
      let map = {}
      PROD_MODIFY_STATUS.forEach(item => {
        map[item.value] = item.label
      });
      return map
    },
    
  },
  methods: {
    ...mapActions(['publishSpeed']),
    ...mapMutations(['setCurrentPage']),
    jumpDetail(rowData) {
      // 使用 Vue Router 的 push 方法进行路由跳转
       this.$router.push({
          name: `${this.routerPrefix}prod_log`,
          query:{
            id: rowData.id,
            operateSubType:this.operateSubTypeMap[rowData.operateSubType] || '',
            startTime:rowData.startTime
          }
      })
    },
    async getStaffData(){
      let res = await getStaffList({
        pageNo: 1,
        pageSize: 9999999
      });
      if (res && res.list) {
        (res.list || []).forEach(item => {
          this.$set(this.staffMap,[item.id],item.accountName)
        })
      }
    },
  },
  created(){
    this.getStaffData();
  }
};
</script>

<style lang="scss" scoped>

</style>
